import { dateMatchesSearch } from "~/shared/utils/date-search.ts";

import { formatCurrency } from "./quote-board-data-transformers.ts";

/**
 * Custom Kendo filter operators for Quote Board columns whose rendered text
 * differs from the raw bound field (ISO dates, bare numbers). Without these,
 * typing the text shown in the cell — `09/25/2025`, `$1,234.00`, `1234 lbs` —
 * matches nothing. Columns keep binding to the raw value so sorting stays
 * chronological/numeric.
 */

const containsText = (haystack: string, needle: string): boolean =>
	haystack.toLowerCase().includes(needle.toLowerCase());

export const dateContainsOperator = (
	fieldValue: Date | string | null | undefined,
	filterValue: string,
): boolean => dateMatchesSearch(fieldValue, filterValue, "local");

// Currency matching is lenient: `$` and `,` are stripped from both sides so
// `1234`, `1,234` and `$1,234.00` all match a rendered `$1234.00`.
const stripCurrencySymbols = (value: string): string =>
	value.replaceAll(/[$,]/g, "");

export const currencyContainsOperator = (
	fieldValue: number | string | null | undefined,
	filterValue: string,
): boolean => {
	if (!filterValue) return true;
	return containsText(
		stripCurrencySymbols(formatCurrency(fieldValue)),
		stripCurrencySymbols(filterValue),
	);
};

export const weightContainsOperator = (
	fieldValue: number | string | null | undefined,
	filterValue: string,
): boolean => {
	if (!filterValue) return true;
	return containsText(`${fieldValue ?? 0} lbs`, filterValue);
};
